import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITasks, ITasksState } from './types/Tasks-interface';
import { fetchTasksList } from './actions/fetch-tasks-list';


const initialState: ITasksState = {
    Tasks: [],
    TaskCount: 0,
    isLoadingTasks: false,
    errorTasks: [],
    lastFetchTime: null,
    contractsID: [],
    currentPage: 1,
    currentPageInCase: 1
};

export const TasksList = createSlice({
    name: 'TasksList',
    initialState,
    reducers: {
        resetTasksData: (state) => {
            state.Tasks = [];
            state.TaskCount = 0;
            state.isLoadingTasks = false;
            state.errorTasks = [];
            state.lastFetchTime = null;
            state.contractsID = [];
            state.currentPage = 1;
            state.currentPageInCase = 1;
        },
        setCurrentPageTasks: (state, action: PayloadAction<{ page: number }>) => {
             state.currentPage = action.payload.page;
         },
         setCurrentPageInCaseTasks: (state, action: PayloadAction<{ page: number }>) => {
            state.currentPageInCase = action.payload.page;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTasksList.pending, (state) => {
                state.isLoadingTasks = true;
            })
            .addCase(fetchTasksList.fulfilled, (state, action: PayloadAction<{ tasks: ITasks[], taskCount: number, fetchTime: number, contractID: string[] | [] }>) => {
                state.isLoadingTasks = false;
                state.Tasks = action.payload.tasks;
                state.TaskCount = action.payload.taskCount;
                state.errorTasks = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.contractsID = action.payload.contractID;
                state.currentPage = state.currentPage;
                state.currentPageInCase = state.currentPageInCase;
            })
            .addCase(fetchTasksList.rejected, (state, action) => {
                state.Tasks = [];
                state.isLoadingTasks = false;
                state.errorTasks = action.payload as string[];
                state.contractsID = [];
                state.currentPage = 1;
                state.currentPageInCase = 1;
            });
    },
});

export const { resetTasksData, setCurrentPageTasks, setCurrentPageInCaseTasks } = TasksList.actions;
export default TasksList.reducer;